var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"simple-layout"},[_c('div',{staticClass:"simple-layout__container"},[_vm._t("default")],2),_vm._m(0),(_vm.user)?_c('LayoutSwitchLang'):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-layout__image"},[_c('img',{attrs:{"src":require("@/assets/images/home.png"),"alt":"Faume dashboard"}})])
}]

export { render, staticRenderFns }